module.exports = __webpack_public_path__ + "static/media/shinySword.57404d01.jpg";